import { render, staticRenderFns } from "./UiNavItem.vue?vue&type=template&id=feeaee82&"
import script from "./UiNavItem.vue?vue&type=script&lang=js&"
export * from "./UiNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports